import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useLocation, useParams } from 'react-router';
import { uploadTypes } from './uploadTypes';
import Form from '../../../Components/Boilerplates/Forms/Forms';
import AUX from '../../../hoc/AU-X/AU-X';

const Items = [
  { title: 'اضافه موردی', url: 'AddInvidualData' },
  { title: 'آپلود اطلاعات', url: 'UploadData' },
  // { title: 'دریافت اطلاعات', url: 'chigao' },
  { title: 'لیست', url: 'GetData' },
];

const specials = [
  {
    self: 'Dam',
    childs: [
      { url: 'DamHumanUsage', title: 'سد' },
      { url: 'DamHumanVolume', title: 'حجم' },
    ],
  },
  {
    self: 'Lake',
    childs: [
      { url: 'LakeLevel', title: 'تراز' },
      { url: 'LakeEvaporation', title: 'تبخیر' },
    ],
  },
];

const Upload = () => {
  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...uploadTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);
  const location = useLocation();

  console.log(thisPageData);

  const allInputs = useMemo(() => {
    const inputs = thisPageData.inputs && thisPageData.inputs.slice();

    let ifCheck = -1;
    specials.forEach((e, i) => {
      e.childs.forEach((element) => {
        if (element.url === type) {
          ifCheck = i;
        }
      });
    });

    if (
      location.state &&
      (location.state.page === type || (ifCheck !== -1 && location.state.page === specials[ifCheck].self)) &&
      location.state.options
    ) {
      inputs[0] = {
        ...inputs[0],
        elementConfig: {
          ...inputs[0].elementConfig,
          type: 'select',
          options: location.state.options,
        },
        indexValue: -1,
      };

      inputs.push({
        id: 'file',
        elementConfig: {
          type: 'file',
          accept: 'csv',
          placeholder: type,
        },
        value: '',
        validation: {
          required: true,
        },
        valid: false,
        touched: true,
        single: true,
      });
    }

    return inputs;
  }, [location, thisPageData, type]);

  const beforeForm = useMemo(() => {
    let specialIndex = -1;
    specials.forEach((element, i) => {
      element.childs.forEach((e) => {
        if (type === e.url) {
          specialIndex = i;
        }
      });
    });

    if (specialIndex !== -1) {
      return (
        <AUX>
          <ul
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: '100%',
              margin: '9px 0',
            }}
          >
            {Items.map((item) => (
              <li style={{ width: '100%' }} key={item.url}>
                <div>{item.title}</div>
              </li>
            ))}
          </ul>
          {specials[specialIndex].childs.map((item, i) => (
            <div className='grid-3' style={{ margin: '5px 0', padding: '0' }} key={item.url}>
              {Items.map(
                (upload, index) =>
                  index < 2 && (
                    <NavLink
                      key={upload.url}
                      className={
                        location.pathname.indexOf(item.url) !== -1 && location.pathname.indexOf(upload.url) !== -1
                          ? 'activeItem'
                          : ''
                      }
                      to={{
                        pathname: `/${upload.url}/${item.url}`,
                        state: location.state,
                      }}
                    >
                      مربوط به {item.title}
                    </NavLink>
                  )
              )}

              {i === 0 && (
                <NavLink
                  className={location.pathname.indexOf('GetData') === -1 ? '' : 'activeItem'}
                  to={{
                    pathname: `/GetData/${specials[specialIndex].self}`,
                    state: location.state,
                  }}
                >
                  لیست
                </NavLink>
              )}
            </div>
          ))}
        </AUX>
      );
    } else {
      return (
        <div className='grid-3'>
          {Items.map((item) => (
            <NavLink
              className={location.pathname.indexOf(item.url) === -1 ? '' : 'activeItem'}
              to={{
                pathname: `/${item.url}/${type}`,
                state: location.state,
              }}
              key={item.url}
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      );
    }
  }, [location, type]);

  return (
    <Form
      inputs={allInputs}
      url={thisPageData.url}
      pageTitle={'اضافه جزئیات ' + thisPageData.title}
      header={{ Authorization: `Bearer ${token}` }}
      goBack={`/`}
      beforeForm={beforeForm}
    />
  );
};

export default Upload;
